import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/global';

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { Urls } from 'js/src/client';
import PublicPagesTrim from 'js/src/components/common/public-pages/PublicPagesTrim';
import PageTerms from 'js/src/components/public-pages/PageTerms';
import PageTermsGetty from 'js/src/components/public-pages/PageTermsGetty';
import PageTermsShutterstock from 'js/src/components/public-pages/PageTermsShutterstock';
import PageTermsVideoblocks from 'js/src/components/public-pages/PageTermsVideoblocks';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { renderComponent } from 'js/src/libs/redux-utils';

ErrorReporter.init(Project.FRONTEND);

const PageTermsContainer = React.memo(function PageTermsContainer() {
    return (
        <PublicPagesTrim headerBackgroundColor="White">
            <Router>
                <Routes>
                    <Route path={Urls.TERMS} element={<PageTerms />} />
                    <Route path={Urls.TERMS_VIDEOBLOCKS} element={<PageTermsVideoblocks />} />
                    <Route path={Urls.TERMS_GETTY} element={<PageTermsGetty />} />
                    <Route path={Urls.TERMS_SHUTTERSTOCK} element={<PageTermsShutterstock />} />
                </Routes>
            </Router>
        </PublicPagesTrim>
    );
});

renderComponent(PageTermsContainer);
